import api from ".";

export const integrantes = async (novoColaborador) => api.post(`plantao/integrantes`, novoColaborador);

export const retornaIntegrantes = async (plantaoId) => {
    try {
        const { data } = await api.get("plantao/retornaIntegrantes", {
            params: { plantaoId },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const duplicidade = async (plantaoId, pessoaId) => {
    try {
        const { data } = await api.get("plantao/duplicidade", {
            params: { plantaoId, pessoaId },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const imprimirPlantao = (url, dadosFiltrados) =>
    api.post(`/plantao/imprimirPlantao/?${url.toString()}`, dadosFiltrados, {
        responseType: "arraybuffer",
    });
/**
 *
 * @param {*} obj { start, size, filters, filtersMode, globalFilter, sorting, equipeId }
 * @returns data
 */
export const listarIntegrantes = async ({ start, size, filters, filtersMode, globalFilter, sorting, plantaoId }) => {
    if (!plantaoId) {
        return [];
    }
    try {
        const { data } = await api.get("plantao/listarIntegrantes", {
            params: { start, size, filters, filtersMode, globalFilter, sorting, plantaoId },
        });
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

//services para o plantão
export const obterPlantaoByIdOrUUID = async (obj) => {
    try {
        const { data } = await api.post("obterPlantao", obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const obterPlantaoNaoConcluido = async (obj) => {
    try {
        const { data } = await api.post("obterPlantaoAberto", obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
export const obterPlantaoTipos = async (obj) => {
    try {
        const { data } = await api.post("obterPlantaoTipos", obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};

//para carregar um datalist preciso obter uma lista de integrantes do plantao
export const colaboradoresByPlantao = async (obj) => {
    try {
        const { data } = await api.post("colaboradoresByPlantao", obj);
        return data;
    } catch (error) {
        console.error(error);
        return error;
    }
};
